import CardAvatar from "@/components/cardElements/CardAvatar";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
type Props = {
  onClick: () => void;
  label: string;
  userName?: string;
  userImage?: string;
  subtitle?: string;
  className?: string;
};
export function MessageFab({
  onClick,
  label,
  userName,
  userImage,
  subtitle,
  className
}: Props) {
  return <Button type="button" variant="defaultGradient" onClick={onClick} className={cn("absolute bottom-safe-9 left-1/2 z-50 flex h-auto -translate-x-1/2 items-center gap-2.5 rounded-full py-0.5 pl-0.5 pr-5 shadow-lg border-2 border-white/80", className)} data-sentry-element="Button" data-sentry-component="MessageFab" data-sentry-source-file="MessageFab.tsx">
      <CardAvatar imgUrl={userImage} name={userName} className="h-12 w-12 border-2 border-primary" data-sentry-element="CardAvatar" data-sentry-source-file="MessageFab.tsx" />
      <div className="flex flex-col items-start leading-tight">
        {subtitle && <span className="text-[11px] text-white/80">{subtitle}</span>}
        <span className="text-sm">{label}</span>
      </div>
    </Button>;
}